export default "__VITE_ASSET__ba89a89d__"